// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store.js'
import locale from 'element-ui/lib/locale/lang/ja'
import ElementUI from 'element-ui'
import VeeValidate, { Validator } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'
import VueAnalytics from 'vue-analytics'
import './element-variables.scss'

require('@/assets/style/common.scss')

Vue.use(ElementUI, { locale })

Vue.use(VeeValidate);
Validator.localize('ja', ja);

Vue.config.productionTip = false


//======================
//Setting:VueCookies
//======================
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

//======================
//Setting:VueAnalytics
//======================
Vue.use(VueAnalytics, {
  id: 'UA-136097623-1',//GoogleAnalytics
  router// routerを使っているので必須
})
//---Setting:VueAnalytics


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js